<template>

    <!--
    Deprecated ... do not use anylonger ...

    -->

    <div class="container-fluid px-0" v-if="step == 1">
        <div class="row">
            <div class="col">
                <label class="d-block">Client</label>
                <div class="-input-group -w-100">
                    <client-ac 
                        v-model="model.Client"
                        class="flex-grow-1"
                        inputclass="form-control rounded-end-0"
                        placeholder="Select a client"
                    ></client-ac>
                    <!-- 
                    <button class="btn btn-secondary" @click="editClient(model.Client)" v-if="model.Client">
                        <i class="fa fa-edit"></i>
                    </button>
                    <button class="btn btn-primary" @click="editClient()">
                        <i class="fa fa-plus"></i>
                    </button>
                    -->
                </div>
            </div>
        </div>
        <div class="row mt-2">
            <div class="col">
                <div class="input-group w-100 flex-nowrap">
                    <job-select
                        class="flex-grow-1"
                        v-model="model.Job"
                        :client="model.Client"
                        inputClass="rounded-end-0"
                        :status="[0,1,11,12,13,21]"
                        label="Job"
                    ></job-select>
                    <!-- 
                    <button class="btn btn-secondary h-25 mt-auto" @click="editJob(model.Job)" v-if="model.Job">
                        <i class="fa fa-edit"></i>
                    </button>
                    <button class="btn btn-primary h-25 mt-auto" @click="editJob(model.Job)">
                        <i class="fa fa-plus"></i>
                    </button>
                    --> 
                </div>
            </div>
        </div>
        <!-- REMOVED per RS 
        <div class="row mt-2">
            
            <div class="col">
                <kt-input
                    label="Per Hour Rate"
                    placeholder="Billable rate per hour"
                    v-model="model.Rate"
                ></kt-input>
            </div>
        </div>
        -->
        <!-- TODO 
        <hr class="mt-3" />
        <div class="row mt-3">
            <div class="col">
                <kt-select 
                    label="Or pick from your open jobs"
                    options="ownedJobs"
                    label-key=""
                    value-key=""
                    @change="selectJob($event)"
                ></kt-select>
            </div>
        </div>
        -->
        <hr class="my-3" />
        <button class="btn btn-primary form-control" @click="pickTime()">
            <span v-if="props.mode == 1">Start Clock</span>
            <span v-if="props.mode == 2">Switch</span>
        </button>
    </div>

    <div class="container-fluid" v-if="step == 2">
        <div class="row">
            <div class="col mx-auto" v-if="selectedJob">
                <strong>Client:</strong> {{ selectedJob.Contact.Company }}<br />
                <strong>Job:</strong> {{ selectedJob.RequestDetailedDescription || selectedJob.TaskDetail }}
            </div>
        </div>
        
        <hr />
        
        <div class="row mt-2">
            <div class="col">
                <button class="btn btn-primary form-control" @click="startClock()">
                    Now
                </button>
            </div>
        </div>

        <div class="row mt-3">
            <div class="col">
                <button class="btn btn-primary form-control" @click="specifyTime()">
                    Specify Time
                </button>
            </div>
        </div>

        <div class="row mt-3" v-if="props.mode != 3">
            <div class="col">
                <button class="btn btn-primary form-control" @click="step = 1">
                    Back
                </button>
            </div>
        </div>
    </div>

    <div class="container-fluid" v-if="step == 3">

        <div class="row">
            <div class="col mx-auto" v-if="selectedJob">
                <strong>Client:</strong> {{ selectedJob.Contact.Company }}<br />
                <strong>Job:</strong> {{ selectedJob.RequestDetailedDescription || selectedJob.TaskDetail }}
            </div>
        </div>
        
        <hr />

        <div class="row">
            <div class="col">
                <kt-input
                    type="date"
                    label="Date"
                    placeholder="Choose date"
                    v-model="model.Date"
                ></kt-input>
            </div>
        </div>

        <div class="row">
            <div class="col">
                <kt-input
                    type="time"
                    label="Time"
                    placeholder="Choose time"
                    v-model="model.Time"
                ></kt-input>
            </div>
        </div>

        <div class="row mt-3">
            <div class="col-md-6">
                <button class="btn btn-secondary form-control" @click="step = 2">
                    Back
                </button>
            </div>
            <div class="col-md-6">
                <button class="btn btn-primary form-control" @click="startClock(true)">
                    OK
                </button>
            </div>
        </div>

    </div>


</template>

<script setup>

import { ref, watch, onMounted } from "vue";
import { useRoute, useRouter } from "vue-router";
import KtInput from "@/components/UI/KtInput.vue";
import Events from "@/services/Emitter";
import KtSelect from "@/components/UI/KtSelect.vue";
import ClientAc  from "@/components/Clients/ClientAc.vue";
import JobSelect from "@/components/Jobs/JobSelect.vue";
import Alert from "@/services/Alert";
import Api from "@/services/Api";
import Helper from "@/services/Helper";

const props = defineProps([
    "mode",
]);

const emits = defineEmits([
    
    "submit",
    "change",
    "stop",

    /*
    // -- these are now handled in the Client and Job selector components.
    "editClient",
    "editJob",
    */
]);

const model = defineModel({
    Client: "",
    Job: "",
    Date: "",
    Time: "",
    Rate: "",
    Task: "",
    Clock: "",
});

const editClient = (val) =>
{
    emits("editClient", val);
};

const editJob = (val) =>
{
    emits("editJob", val);
};

const route = useRoute();
const router = useRouter();

const ownedJobs = ref([]);
const step = ref(1);
const selectedJob = ref(null);

watch(() => model.value.Job, async (nv, ov) => {
    if (nv)
    {
        let row = await Api.loadJob(nv);
        selectedJob.value = row;
    }
});

const pickTime = () =>
{
    if (!model.value.Client || !model.value.Job)
    {
        Alert.notify({
            text: "Please select a Client and Job"
        });
        return;
    }

    if (props.mode == 1)
    {
        step.value = 2;
    }

    else
    {
        emits("change", model.value);
    }

};

const specifyTime = () =>
{
    let tmp = new Date();
    model.value.Date = Helper.dateToInput(tmp, Helper.DateFormat_Date);
    model.value.Time = Helper.dateToInput(tmp, Helper.DateFormat_Time);
    step.value = 3;
}

const selectJob = async (job) =>
{
    model.value.Client = job.Customer;
    model.value.Job = job.ID;
};

const startClock = (check) =>
{
    let pay = {
        Client: model.value.Client,
        Job: model.value.Job,
        Rate: model.value.Rate
    };

    if (model.value.Task) {
        pay.Task = model.value.Task;
    }

    if (check) {
        if (!model.value.Date || !model.value.Time)
        {
            Alert.notify({
                text: "Please pick a Date and Time"
            });
            return;
        }

        pay.Date = model.value.Date;
        pay.Time = model.value.Time;
    }

    else
    {
        pay.Date = Helper.dateToInput(new Date(), Helper.DateFormat_Date);
        pay.Time = Helper.dateToInput(new Date(), Helper.DateFormat_Time);
    }

    if (props.mode == 3)
    {
        pay.Task = model.value.Task;
        pay.Clock = model.value.Clock;
        emits("stop", pay);
    }

    else
    {
        emits("submit", pay);
    }

};

onMounted(async () =>
{
    // ...
    if (props.mode === 3) {
        step.value = 2;
    }

    let rec = route.params.type;
    if (!isNaN(rec)) 
    {

        let rs = await Api.loadTime(rec);
        console.debug(rs);

        if (rs && rs.Clock != null) {
            Alert.notify({
                text: "This task already has an active clock assigned to it. " +
                "Please use a different one." 
            });

            router.push({
                path: "/time/list"
            });
            return;
        }

        model.value.Client = rs.Contact.CustomerNumber;
        model.value.Job = rs.RequestId;
        model.value.Task = rec;
    }
});

</script>